import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { AuthShell, FormError } from "./AuthShell";

export default function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await login(email, password);
      navigate(user.email_verified ? location.state?.from || "/app" : "/check-email", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Welcome back" title="Sign in to EVR"
      footer={<>New here? <Link to="/signup" data-testid="signin-to-signup-link" className="font-medium text-navy underline underline-offset-4">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="signin-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" data-testid="signin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" className="h-11" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" data-testid="signin-forgot-link" className="text-xs text-slate-600 hover:text-navy underline underline-offset-4">Forgot password?</Link>
          </div>
          <Input id="password" type="password" data-testid="signin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" className="h-11" />
        </div>
        <FormError message={error} testId="signin-error" />
        <Button type="submit" disabled={busy} data-testid="signin-submit-button" className="h-11 w-full bg-navy hover:bg-navy-2">
          {busy ? "Signing in..." : "Sign in"}
        </Button>
      </form>
    </AuthShell>
  );
}
